import { request } from "@/plugins/request";

export const eventsService = {
  async getEvent(id) {
    return await request({
      url: `/events/${id}/`,
      method: "get",
    });
  },
};
